import React from "react";
import "./Header.css";

function Header({callback}) {
  

  const data1=1;
  const data2=2;
  const data3=3;
  const data4=4;
  const data5=5;






 
  return (
    <div className="header">
      <div className="header__left">
        <ul>
          <li>
            <a  className="active"onClick={()=>callback(data1)}>
              Popular 
            </a>
          </li>
          <li>
            <a className="active1"onClick={()=>callback(data2)}>Hot </a>
          </li>
          <li>
            <a className="active2"onClick={()=>callback(data3)}>Rising </a>
          </li>
          <li>
            <a  className="active3"onClick={()=>callback(data4)}>Controversial</a>
          </li>
          <li>
            <a className="active4"onClick={()=>callback(data5)}>Glided </a>
          </li>
        </ul>
      </div>
      <div className="header__right">
        <i className="fas fa-bell"></i>
        {/* <img src=""  alt="img"/> */}
        <div className="header__user">
       
          {/* <i className="fas fa-caret-down"></i> */}
        </div>
      </div>
    </div>
  );
  }

export default Header;